

import { Component, Prop, Vue } from 'vue-property-decorator';
import { namespace } from "vuex-class";

import "@/store/modules/common";
const commonState = namespace("Common");

import StepNumber from "@/components/utils/StepNumber.vue";
import { form1StatusInfoType, accountInfoType } from '@/types/Information/Form1';

@Component({
    components:{
        StepNumber
    }
})
export default class Form1ProcessHeader extends Vue {  
    
    @Prop({required: true})
    stepsCompleted!: form1StatusInfoType;

    @commonState.State
    public accountInfo!: accountInfoType;

    textInactiveStepIncompleteClass = 'text-inactive step-incomplete';
    textDarkStepIncompleteClass = 'text-dark step-incomplete';

    dataReady = false;
    enableAccessPage = false;

    mounted(){
        this.dataReady = false;
        this.enableAccessPage = this.accountInfo?.accountUsers?.length > 1;
        this.dataReady = true;
    }

    public navigateToAccessPage(){
        if (this.enableAccessPage){
            this.$router.push({name: "access-form1"});
        }
    }

}
